import { render, staticRenderFns } from "./FileClaimEnd.vue?vue&type=template&id=57491208"
import script from "./FileClaimEnd.vue?vue&type=script&lang=js"
export * from "./FileClaimEnd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports